export default {
	site_name: 'camber-collective',
};
